<template>
  <section class="section dashboard">
    <VectorWidgets v-for="vector in userVectors" :key="vector" :vector="vector"/>
  </section>
</template>

<script>
import VectorWidgets from './Dashboard/VectorWidgets/VectorWidgets'

const ELECTRIC_ENERGY = 'EE';

export default {
  components: {
    VectorWidgets,
  },

  computed: {
    userVectors() {
      if (!this.$store.state.user) {
        return [];
      }

      // Put Electric Energy widget first
      const vectors = this.$store.state.user.vectors.filter(v => v != 't' && v != 'water');

      if (! vectors.includes(ELECTRIC_ENERGY)) {
        return vectors;
      }

      const electricWidgetIndex = vectors.findIndex((widgetKey) => widgetKey === ELECTRIC_ENERGY);

      return [
        ELECTRIC_ENERGY,
        ...vectors.slice(0, electricWidgetIndex),
        ...vectors.slice(electricWidgetIndex + 1),
      ];
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/DashboardMono.vue